export const parseMessageText = (msg: string) => {
  if (!msg || msg === "null") return '';

  msg = msg.replace(/`\n/g, '')
    .replace(/`/g, '');

  msg = msg.replace(/\n/g, '<br>')
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold
    .replace(/\*(.*?)\*/g, '<em>$1</em>') // Italics
    .replace(/`(.*?)`/g, '<code>$1</code>') // Inline code
    .replace(/&gt;\s?(.*?)<br>/g, '<blockquote>$1</blockquote><br>'); // Blockquotes

  if (msg.startsWith('<br>')) {
    msg = msg.substring(4);
  }

  return msg;
};

export const parseUserMessage = (msg: string) => msg.replace(/\[PII\]/g, '<span class="voa-blur-effect">[PII]</span>')

interface ParsedMessageChunk {
  type: "message" | "hyperlink";
  text: string;
  url?: string;
}

export const parseMessageLinks = (message: string) => {
  const out: ParsedMessageChunk[] = [];

  // didn't work with anchor links
  // const regex = /!?(\[(.*?)\]\((((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w\-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?))\))/gi;
  const regex = /!?\[([^\]]*)\]\(((?:[^()]|\((?:[^()]|\((?:[^()]*)\))*\))*)\)/g;

  const matches = message.matchAll(regex);

  let lastFlag = 0;

  for (const match of matches) {
    const start = match.index;
    const end = start + match[0].length;

    const textBeforeLink = message.slice(lastFlag, start);

    if (textBeforeLink) {
      out.push({
        type: "message",
        text: textBeforeLink
      })
    }

    const hyperlink = message.slice(start, end);

    // if (hyperlink.startsWith('!')) {
    //   out.push({
    //     type: "hyperlink",
    //     text: match[2],
    //     url: match[4]
    //   });
    // } else {
      out.push({
        type: "hyperlink",
        text: match[1],
        url: match[2]
      });
    // }    

    lastFlag = end;
  }

  if (lastFlag < message.length) {
    const lastText = message.slice(lastFlag, message.length);

    if (lastText) {
      out.push({
        type: "message",
        text: lastText
      })
    }
  }

  return out;
};

export const parseMessage = (msg: string, sendMessageLog?: () => void) => {
  if (!msg && msg === "null") return '';
    const messageCopy = msg;

    const parseResult = parseMessageLinks(messageCopy);

    const result = parseResult.reduce((acc, chunk) => {
      const { type, text, url } = chunk;

      if (type === "message") {
        return acc + parseMessageText(text);
      } else if (type === "hyperlink") {
        if (sendMessageLog) {
          sendMessageLog()
        }
        return acc + (
          `<p data-nav-url="${url}" class="voa_chat_bot_message_text_hyperlink message__link">${parseMessageText(text)}</p>`
        );
      }

      return acc
    }, '');
    return result
}

export default parseMessage;
